module.exports = __webpack_public_path__ + "img/Teacher_invite_declined_dark.71da611d.svg";